import React, { useEffect, useState } from "react";

import { Container, Table } from "./styles";
import { addDays, format } from "date-fns";
import { useNavigate } from "react-router-dom";
import Status from "../../../components/status";
import { Card, HeaderTitle, Message } from "../../../GlobalStyles";
import { toast } from "react-toastify";
import api from "../../../services/api";
import {
  MdAccountBalance,
  MdAdd,
  MdStickyNote2,
  MdVisibility,
} from "react-icons/md";
import { getDate, getValue } from "../../../services/functions";
import {
  Button,
  Pagination,
  Spin,
  DatePicker,
  Select,
  Modal,
  Input,
} from "antd";
import locale from "antd/es/date-picker/locale/pt_BR";
import dayjs from "dayjs";
import CountUp from "react-countup";
import { ViewInput } from "../Coupon/styles";
import IntlCurrencyInput from "react-intl-currency-input";
import { currencyConfig } from "../../../services/states";

const DepositosAdmin = () => {
  const navigate = useNavigate();
  const [deposits, setDeposits] = useState([]);
  const [depositsTotal, setDepositsTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState({});
  const [collaborator_id, setCollaborator_id] = useState("");
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [startDate, setStartDate] = useState(addDays(new Date(), -30));
  const [endDate, setEndDate] = useState(new Date());
  const [visibleModal, setVisibleModal] = useState(false);
  const [value, setValue] = useState(0);
  const [bonus, setBonus] = useState(0);
  const [description, setDescription] = useState("");
  const [user_id, setUser_id] = useState("");
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadDeposits(page, startDate, endDate, status, collaborator_id);
  }, [page, startDate, endDate, status, collaborator_id]);

  useEffect(() => {
    loadUsers();
  }, []);

  async function loadUsers() {
    await api
      .get(`/users/franqueado?all=true`)
      .then((response) => {
        setUsers(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadDeposits(
    page,
    startDate,
    endDate,
    status,
    collaborator_id
  ) {
    setIsLoading(true);
    await api
      .get(
        `/admin/deposits?startDate=${startDate}&endDate=${endDate}&page=${page}&status=${status}${
          collaborator_id && `&collaborator_id=${collaborator_id}`
        }`
      )
      .then((response) => {
        setDeposits(response.data.deposits);
        setDepositsTotal(response.data.depositsTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  async function sendBalance() {
    setIsLoadingModal(true);
    if (!user_id || !value) {
      toast.warn("Franqueado e valor são obrigátorios para enviar saldo");
      setIsLoadingModal(false);
    }

    await api
      .post(`/admin/deposit`, {
        value,
        bonus,
        collaborator_id: user_id,
        description,
        type,
      })
      .then(async (ok) => {
        toast.success("Pacote criado com sucesso");
        setPage(0);
        setVisibleModal(false);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingModal(false);
  }

  return (
    <Container>
      <HeaderTitle>
        <h1>Todos Depositos</h1>
        <div>
          <Button
            type="primary"
            style={{
              borderRadius: 50,
              marginRight: 20,
            }}
            onClick={() => navigate("/admin/pacotes")}
          >
            <MdAccountBalance size={20} color="#FFF" />
            Pacotes de Deposito
          </Button>
          <Button
            type="primary"
            style={{
              borderRadius: 50,
            }}
            onClick={() => {
              setValue(0);
              setBonus(0);
              setDescription("");
              setUser_id("");
              setType("");
              setVisibleModal(true);
            }}
          >
            <MdStickyNote2 size={20} color="#FFF" />
            Enviar/Retirar Saldo
          </Button>
        </div>
      </HeaderTitle>

      {isLoading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={depositsTotal} />
          </Card>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              marginBottom: 20,
            }}
          >
            <ViewInput
              style={{ width: "100%", maxWidth: 265, marginRight: 15 }}
            >
              <p>Selecione o Periodo</p>
              <DatePicker.RangePicker
                placeholder={["data inicial", "data final"]}
                value={[
                  startDate ? dayjs(startDate) : "",
                  endDate ? dayjs(endDate) : "",
                ]}
                locale={locale}
                format={"DD/MM/YYYY"}
                onChange={(value, dateString) => {
                  setStartDate(getDate(dateString[0]));
                  setEndDate(getDate(dateString[1]));
                  setPage(0);
                }}
                allowClear={false}
                style={{ width: 265 }}
                onOk={() => {}}
              />
            </ViewInput>
            <ViewInput
              style={{ width: "100%", maxWidth: 200, marginRight: 15 }}
            >
              <p>Filtrar por Franqueado</p>
              <Select
                placeholder="selecionar franqueado"
                value={collaborator_id}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setCollaborator_id(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Franqueados</Select.Option>
                {users.map((item) => {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
            <ViewInput
              style={{ width: "100%", maxWidth: 150, marginRight: 15 }}
            >
              <p>Filtrar por Status</p>
              <Select
                placeholder="selecionar status"
                value={status}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setStatus(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos</Select.Option>
                <Select.Option value="pendente">Pendente</Select.Option>
                <Select.Option value="confirmado">Confirmado</Select.Option>
                <Select.Option value="cancelado">Cancelado</Select.Option>
              </Select>
            </ViewInput>
          </div>
          <div className="orders">
            {depositsTotal ? (
              <Table>
                <thead>
                  <tr>
                    <td>Nome</td>
                    <td>Descrição</td>
                    <td>Valor (Bonus)</td>
                    <td>Status</td>
                    <td>Ultima atualização</td>
                  </tr>
                </thead>
                <tbody>
                  {deposits.map((deposit) => {
                    return (
                      <tr key={deposit.id}>
                        <td style={{ textTransform: "capitalize" }}>
                          {deposit.name}
                        </td>
                        <td style={{ textTransform: "capitalize" }}>
                          {deposit.description || "Sem Descrição"}
                        </td>
                        <td style={{ textTransform: "capitalize" }}>
                          {(deposit.value || 0).toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })}
                          {!!deposit.bonus &&
                            `
                            (${(deposit.bonus || 0).toLocaleString("pt-br", {
                              style: "currency",
                              currency: "BRL",
                            })})`}
                        </td>
                        <td
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Status
                            status={deposit.status}
                            isPayment={true}
                            style={{
                              fontSize: 11,
                              height: 20,
                              paddingBottom: 2,
                            }}
                          />
                        </td>
                        <td>
                          {format(
                            new Date(deposit.update_at),
                            "dd/MM/yyyy HH:mm"
                          )}
                        </td>
                        <td>
                          <MdVisibility
                            size={22}
                            style={{
                              cursor: "pointer",
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            ) : (
              <Message>Nenhum deposito encontrado</Message>
            )}
          </div>
          <center>
            <Pagination
              style={{ marginTop: 15, justifySelf: "center" }}
              defaultCurrent={page + 1}
              onChange={(page) => {
                setPage(page - 1);
              }}
              total={depositsTotal}
              pageSize={30}
            />
          </center>
        </>
      )}
      <Modal
        title={"Enviar/Retirar Saldo"}
        width={500}
        confirmLoading={isLoadingModal}
        open={visibleModal}
        okText={"CONFIRMAR"}
        cancelText="FECHAR"
        onOk={() => {
          sendBalance();
        }}
        onCancel={() => {
          setVisibleModal(false);
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <p style={{ width: "100%", margin: "10px 0 5px 5px", fontSize: 12 }}>
            Tipo de operação
          </p>
          <Button
            type={type == "entrada" && "primary"}
            style={{ width: "48%" }}
            onClick={() => {
              setType("entrada");
            }}
          >
            ENVIAR
          </Button>
          <Button
            type={type == "saida" && "primary"}
            style={{ width: "48%" }}
            onClick={() => {
              setType("saida");
            }}
          >
            RETIRAR
          </Button>
          <ViewInput style={{ width: "100%", marginTop: 5 }}>
            <p>Selecionar Franqueado</p>
            <Select
              placeholder="selecionar franqueado"
              value={user_id || null}
              showSearch
              optionFilterProp="children"
              style={{ width: "100%", textAlign: "left" }}
              onChange={(value) => {
                setUser_id(value);
                if (value) {
                  setUser(users.find((item) => item.id == value));
                }
              }}
            >
              {users.map((item) => {
                return (
                  <Select.Option value={item.id}>{item.name}</Select.Option>
                );
              })}
            </Select>
          </ViewInput>
          <ViewInput style={{ width: "48%" }}>
            <p>Valor do Deposito</p>
            <IntlCurrencyInput
              style={{
                width: "100%",
                backgroundColor: "#FFF",
                borderWidth: 0,
                color: "#000",
                padding: "6px 8px",
                fontSize: 14,
                borderWidth: 1,
                borderColor: "#ccc",
                borderStyle: "solid",
                borderRadius: 2,
                fontWeight: "400",
                paddingLeft: 12,
              }}
              currency="BRL"
              config={currencyConfig}
              value={value}
              onChange={(event, valueEdit) => {
                if (valueEdit >= 0) {
                  setValue(valueEdit);
                } else {
                  setValue(0);
                }
              }}
            />
          </ViewInput>
          <ViewInput style={{ width: "48%" }}>
            <p>Bônus do Deposito</p>
            <IntlCurrencyInput
              style={{
                width: "100%",
                backgroundColor: "#FFF",
                borderWidth: 0,
                color: "#000",
                padding: "6px 8px",
                fontSize: 14,
                borderWidth: 1,
                borderColor: "#ccc",
                borderStyle: "solid",
                borderRadius: 2,
                fontWeight: "400",
                paddingLeft: 12,
              }}
              currency="BRL"
              config={currencyConfig}
              value={bonus}
              onChange={(event, value) => {
                if (value >= 0) {
                  setBonus(value);
                } else {
                  setBonus(0);
                }
              }}
            />
          </ViewInput>
          <ViewInput>
            <p>Descrição*</p>
            <Input.TextArea
              style={{
                minHeight: 50,
              }}
              placeholder="descrição"
              value={description}
              onChange={(event) => setDescription(event.target.value)}
            />
          </ViewInput>
          {user?.id && (
            <div
              style={{
                width: "100%",
                margin: "10px 0 15px 0",
              }}
            >
              <p>Franqueado {user?.name}</p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <p>Saldo atual: {getValue(user?.balance || 0)}</p>
                <p>
                  Novo Saldo:{" "}
                  {getValue(
                    (user?.balance || 0) + (type == "entrada" ? +value : -value)
                  )}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <p>Bônus atual: {getValue(user?.bonus || 0)}</p>
                <p>
                  Novo Bônus:{" "}
                  {getValue(
                    (user?.bonus || 0) + (type == "entrada" ? +bonus : -bonus)
                  )}
                </p>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </Container>
  );
};

export default DepositosAdmin;
